export class CreateMPARequestReviewResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaReview",
            "baseName": "mpaReview",
            "type": "MPAReview",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateMPARequestReviewResponse.attributeTypeMap;
    }
    constructor() {
    }
}
